import { Component, computed, effect, inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { AuthService } from '@user/services/auth.service';
import { ChangePasswordModalComponent } from '../../containers/change-password-modal/change-password-modal.component';
import { DataService } from '@app/user/services/data.service';
import { LanguageSelectorComponent } from '@app/layout/containers/language-selector/language-selector.component';
import { PopoverComponent } from "../popover/popover.component";
import { RouterLink } from '@angular/router';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-header',
    imports: [
        RouterLink,
        TranslatePipe,
        PopoverComponent,
        LanguageSelectorComponent
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    providers: [DialogService],
})
export class HeaderComponent {
    private authService = inject(AuthService);
    private dataService = inject(DataService);
    private dialogService = inject(DialogService);
    private translateService = inject(TranslateService);
    isUserAdmin = false;
    isLoggedIn = false;
    readonly clinicInfo = computed(() => this.dataService.clinic());

    readonly user = this.authService.user;
    isPopoverVisible = false;
    ref: DynamicDialogRef | undefined;

    constructor() {
        effect(() => {
            this.isUserAdmin = this.authService.isUserAdmin();
            this.isLoggedIn = this.authService.isLoggedIn();
        });
    }

    handleSignOut(): void {
        this.hidePopover()
        this.authService.logout();
    }

    hidePopover(): void {
        this.isPopoverVisible = false;
    }

    openChangePasswordModal(): void {
        this.dialogService.open(ChangePasswordModalComponent, {
            width: '35vw',
            modal:true,
            closable: true,
            header: this.translateService.instant('common.changePassword'),
        });
        this.hidePopover();
    }
}
